import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Col } from '../../util_grid/grid.js';
import WishlistToggle from '../../ui_wishlist_toggle/component';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import PriceBlock from '../../base_price-block/component';
import { Button, TitleAndSubtitle, PromoNotification, ProductImage, Badge, Rating } from 'audamatic-ui';
import Link from '../../base_link/component';
import { numFormatToCurrency } from '@utils';
import Text from '@text';

import './styles/styles.scss';


/**
 * The ankeiler Medium is a variant of ankeiler (component).
 * You can render a ankeiler with variant = medium and it will render this component
 *
 * It should be rendered inside a grid.
 *
 * This variant shows a tile with some highlights of a product.
 * Like image, name, price etc and it can have a order button from the medium view and bigger
 *
 * @todo: open sidepanel for vriendenkorting explenation
 * @todo: inbooklist
 * @todo: reserveer
 * @todo: zonder bestelknop
 * @todo: get it working in a grid
 *
 */
class AnkeilerMedium extends Component {
  constructor(props) {
    super(props);

    this.anchorRef = createRef();
    this.ankeilerRef = createRef();

    this.handleClickHelp = this.handleClickHelp.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  get product() {
    return this.props.product;
  }

  get url() {
    return this.product.url || '#';
  }

  get image() {
    return this.product.thumbnail;
  }

  get title() {
    return this.props.title;
  }

  get sku() {
    return this.props.SKU || '';
  }

  get offered() {
    return this.props.offered || 0;
  }

  get type() {
    return this.props.type || '';
  }

  get altText() {
    return this.product.name || '';
  }

  get store() {
    return this.props.store || {};
  }

  /**
   * Get the attributes for the CTA button
   * Tagmanerger stuff
   * eg. data-product etc
   *
   * @todo: this is test
   */
  get extraAttributesCta() {
    return ({ rel: 'nofollow', 'data-type': 'view' });
  }

  /**
   * Get the badges that are in the content. If non specified then return an empty array.
   *
   */
  get badges() {
    return Array.isArray(this.props.badges) ? this.props.badges : this.product.badges;
  }

  /**
   * The help icon toggle
   * can be clicked and then there is a extra text showing
   */
  handleClickHelp(i) {
    const extra = {};
    if (i === '1') {
      extra.help2 = false;
    } else {
      extra.help1 = false;
    }
    return (e) => {
      e.preventDefault();
      this.setState(prevState => ({ [`help${  i}`]: !prevState[`help${  i}`], ...extra }));
    };
  }
  /**
   * Reset some states when you leave the object with you mouse
   */
  handleMouseLeave() {
    this.setState({ help1: false, help2: false });
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushProductGoogleTag(this.props);
  }

  get hasExpandableClass() {
    const { product, info = {} } = this.props;
    if (!product.showAddToCartButton || info.quickOrder) {
      return false;
    }
    return true;
  }

  /**
   * Set giftcard specific subtitle, when the giftcard does not have a fixed price.
   */
  get giftcardSubtitle() {
    const { giftcardDetails = {} } = this.product;
    const { fixed, min, max } = giftcardDetails;
    if (!fixed) {
      return (
        <Text replacements={{
          from: numFormatToCurrency(min),
          to: numFormatToCurrency(max),
        }}>blackhawk.price.range</Text>
      );
    }
    return false;
  }

  render() {
    const { badges, infoBlock, info = {} } = this.props;
    return (
      <Col xs={this.props.xs || 6} sm={this.props.sm || 4} md={this.props.md || 3}
        className={`ankeiler ankeiler-medium ${this.hasExpandableClass ? 'expandable' : ''}`}
        onMouseLeave={this.handleMouseLeave}
        colRef={this.ankeilerRef}
      >
        {!!badges?.length && (
          <span className="tag-wrapper">
            <Badge variant="tag" text={<Text>comp.linebadge.promotion</Text>} size="tiny"/>
          </span>
        )}
        {!info.quickorder && (
          <div className="add-to-booklist-container right" data-test-id="icon-addToWishlist">
            <WishlistToggle product={this.product} store={this.store}/>
          </div>
        )}

        <div className="image wrapper">
          <Link to={this.product.url} title={this.product.name} onClick={this.pushGoogleTags}>
            <div className="product-image-wrapper">
              <ProductImage
                product={this.product}
                maxHeight={149}
                data-test-id="productImage"
              />
            </div>
          </Link>
        </div>
        <div className="ankeiler-anchor" ref={this.anchorRef}>
          {infoBlock}
        </div>
        <div className="equal-cols">
          <div className="layout-top haslink">
            <TitleAndSubtitle
              title={this.title}
              subtitle={this.product.isGiftcard ? this.giftcardSubtitle : this.product.personsLinks}
              data-test-id="titleAndSubtitle"
            />
            {!!this.badges.length && (
              <div className="notification-wrap">
                <PromoNotification
                  size="small"
                  title={badges[0].title}
                  subtitle={badges[0].subtitle}
                  link={badges[0].link}
                />
              </div>
            )}
          </div>
          <div className="ankeiler-container">
            <div className="layout-middle">
              <PriceBlock
                product={this.product}
                store={this.store}
              />
            </div>
            <div className="layout-bottom">
              <div className="block-extend">
                <div className="meta-info">
                  <p className="edition">{this.product.type}</p>
                  {this.product.rating && (
                    <div className="product-rating">
                      <Rating size="small" rating={this.product.rating}/>
                    </div>
                  )}
                </div>

                <span>
                  <div className="row-centered decorated">
                    <div className="to-basket">
                      {this.product.isGiftcard ? (
                        <div className="giftcard-button">
                          <Link className="no-underline" to={this.url} onClick={this.pushGoogleTags}>
                            <Button variant="primary" size="large" fullWidth={true}>
                              <Text>blackhawk.ankeiler.button.text</Text>
                            </Button>
                          </Link>
                        </div>
                      ) : (
                        <AddToCartButton hideIcon store={this.store} product={this.product} showQuantity={false} />
                      )}
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  }
}

/**
 * The most props are part of the general product JSON
 * see the general product JSON
 *
 */
AnkeilerMedium.propTypes = {
  /**
   * The type of medium like 'eBook'
   * see the general product JSON
   */
  type: PropTypes.string,
  /**
   * A string of a comma seperated list of SKU's of other editions( hard-cover,eBook)
   * see the general product JSON
   */
  otherEditions: PropTypes.string,
  /**
   * The images object
   * see the general product JSON
   */
  images: PropTypes.object,
  /**
   * The rating for the product
   * 0-10
   * see the general product JSON
   */
  rating: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
   * The SKU of the product
   * see the general product JSON
   */
  SKU: PropTypes.string,
  /**
   * The url for the product detail page
   * see the general product JSON
   */
  url: PropTypes.string,

  /**
   * The name of the product
   * see the general product JSON
   */
  name: PropTypes.string,
  /**
   * The priceobject of the product
   * see the general product JSON
   */
  price: PropTypes.object,
  /**
   * The badges to show over the ankeiler
   * Follow the badges component data
   */
  badges: PropTypes.array,
  /**
   * Function that returns google tag push to datalayer
   *  methods for ankeilers
   */
  googleTagMethods: PropTypes.func,
  /**
   * The store
   */
  store: PropTypes.object,
  offered: PropTypes.number,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  'image-shadow': PropTypes.bool,
  /**
   * Detect if users browser is IE
   */
  product: PropTypes.object,
  /**
   * Info block component
   */
  infoBlock: PropTypes.node,
  hasInfo: PropTypes.bool,
  info: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
  title: PropTypes.object,
};


export default AnkeilerMedium;
